export const dateFormatNoTime = 'DD.MM.YYYY'
